import * as React from "react";

import { useSuccessPresenter_asController } from "../providers";

import { ThankYou } from "../thank-you";
import { Fragment_Delivery } from "../fragment-delivery";
import { JoinOurRewardsProgram } from "../join-our-rewards-program";
import { CustomerSupport } from "../customer-support";
import { FragmentDeliveryAddress } from "../fragment-delivery-address";

export const PageSuccess: React.FunctionComponent = () => {
  const { handleSuccessPageAppeared } = useSuccessPresenter_asController();

  React.useEffect(() => {
    handleSuccessPageAppeared();
  }, []);

  return (
    <React.Fragment>
      <ThankYou />

      <section className="order-loyalty-support">
        <section className="your-order-summary">
          <h2>{`Delivery`}</h2>
          <Fragment_Delivery />

          <h2 className="delivery-address-header">{`Delivery Address`}</h2>
          <section className="delivery-address">
            <FragmentDeliveryAddress />
          </section>
        </section>

        <section className="loyalty-and-support">
          <JoinOurRewardsProgram />

          <CustomerSupport />
        </section>
      </section>
    </React.Fragment>
  );
};
